<template>
  <div>
    <div class="c-social-posts-carousel" v-if="marketing">
      <ul
        class="juicer-feed"
        :data-feed-id="feedId"
        :data-per="pageSize"
        :data-pages="pageLimit"
        :data-truncate="contentMaxLength"
        :data-columns="columns"
        :data-interval="slideInterval"
        data-style="slider"
        data-overlay="false"
      ></ul>
    </div>
    <div v-if="!marketing">
      <onetrust-blocker></onetrust-blocker>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'c-social-posts-carousel',
  props: {
    pageSize: {
      type: Number,
      default: 30,
    },
    pageLimit: {
      type: Number,
      default: 5,
    },
    contentMaxLength: {
      type: Number,
      default: 600,
    },
    columns: {
      type: Number,
      default: 3,
    },
    slideInterval: {
      type: Number,
      default: 0,
    },
    feedId: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('onetrust', [
      'marketing'
    ])
  },
  data() {
    return {
      section: null
    }
  },
  mounted() {
    document.addEventListener('DOMContentLoaded', () => {
      const socialPostsContainer = document.querySelector('.c-social-posts-carousel--container')
      if (socialPostsContainer) {
        const titleElement = socialPostsContainer.querySelector('.title')
        this.section = titleElement ? titleElement.innerText : 'Social Posts Carousel'

        const startTime = new Date()
        const interval = setInterval(() => {
          const currentTime = new Date()
          if ((currentTime - startTime) === (1000 * 60)) { // 1 minuto
            clearInterval(interval)
            return
          }
          const jMessageLinks = socialPostsContainer.querySelectorAll('.j-message a')
          const jMetaLinks = socialPostsContainer.querySelectorAll('.j-meta a')
          if (jMessageLinks.length && jMetaLinks.length) {
            if (jMessageLinks) {
              jMessageLinks.forEach(this.AddMessageLinkClickListener)
            }

            if (jMetaLinks) {
              jMetaLinks.forEach(this.AddMetaLinkClickListener)
            }
            clearInterval(interval)
          }
        }, 1000)
      }
    })
  },
  methods: {
    AddMessageLinkClickListener(messageLink) {
      messageLink.addEventListener('click', () => {
        window.dataLayer.push({
          event: 'click',
          name: 'link-view',
          section: this.section,
          component_type: 'link',
          link_url: messageLink.href,
          outbound: true
        })
      })
    },
    AddMetaLinkClickListener(metaLink) {
      metaLink.addEventListener('click', () => {
        window.dataLayer.push({
          event: 'click',
          name: 'icon-view',
          section: this.section,
          component_type: 'icon',
          link_url: metaLink.href,
          outbound: true
        })
      })
    }
  }
}
</script>

<style lang="scss">
.c-social-posts-carousel--container {
  background-color: white;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;

  &.left {
    text-align: left;
  }

  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }
}

.c-social-posts-carousel {
  $text-color: black;
  $border-radius: 0.25rem;
  background-color: white;

  .juicer-feed {
    padding: 0 50px;
    .j-twitter-bg,
    .j-facebook-bg,
    .j-instagram-bg,
    .j-linkedin-bg {
      background-color: white;
    }

    .slick-track {
      height: unset !important;
    }

    .slick-arrow {
      background-color: #9ddda9 !important;
      margin: 130px 0 auto !important;
      padding: 10px 40px !important;
    }

    .slick-prev {
      border-radius: 0 50% 50% 0 !important;
      left: -80px !important;
      transition: left 0.2s ease;

      &:hover {
        left: 0 !important;
      }
    }

    .slick-next {
      border-radius: 50% 0 0 50% !important;
      right: -80px !important;
      transition: right 0.2s ease;
      &:hover {
        right: 0 !important;
      }
    }

    li.feed-item {
      margin: 0 0.25rem;
      padding-top: 30px !important;
      border-radius: $border-radius;
      box-sizing: border-box;
      border: solid 1px !important;
      border-color: #dadada !important;
      display: flex;
      flex-direction: column;
      height: unset !important;

      &.j-twitter {
        padding-top: 40px !important;

        .j-image {
          margin-top: 0.5rem;
        }

        .j-twitter-intents {
          filter: brightness(0.5);
        }

        .j-twitter-quote {
          margin-top: 10px;

          & > br {
            display: none;
          }
          .j-twitter-quote-screen-name {
            margin: 0 0 10px 0.1rem;
            font-size: 0.9em;
          }
        }

        .j-poster a {
          width: unset;
        }

        .j-twitter-post-icon {
          display: flex;
          &:before {
            color: #55acee;
            font-size: 24px;
          }
        }
      }

      &.j-instagram {
        .j-instagram-text-hover {
          background-clip: text !important;
          -webkit-background-clip: text !important;
          color: transparent;
          background: #d6249f;
          background: radial-gradient(
            circle at 30% 107%,
            #fdf497 0%,
            #fdf497 5%,
            #fd5949 45%,
            #d6249f 60%,
            #285aeb 90%
          );
        }
      }

      &.j-facebook {
        .j-facebook-text-hover::before {
          color: #3b5998;
        }
      }

      &.j-linkedin {
        .j-linkedin-text-hover {
          color: #007bb6;
        }
      }

      .j-text {
        position: static !important;
        display: flex;
        flex-direction: column;
        padding: 0.5rem 1rem !important;
        background: none !important;
        text-align: left;
        opacity: 1;
        visibility: visible;
      }

      .j-image {
        position: relative !important;
        display: flex;
        align-items: center;
        max-height: 300px;
        height: 100%;
        margin-top: 1rem;
        img {
          top: 0 !important;
          transform: none !important;
          position: static !important;
          height: 100% !important;
        }

        &.playing + .j-text {
          visibility: visible !important;
          opacity: 1 !important;
        }
      }

      .j-poster {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute !important;
        top: 0;
        left: 0;
        visibility: visible;
        opacity: 1;
        margin: 0;
        padding: 0.5rem 1rem 0 !important;
        a,
        h3,
        time {
          color: $text-color !important;

          &:hover {
            text-decoration: underline;
          }
        }

        a {
          width: 100%;
        }

        .j-date {
          font-weight: lighter;
        }
      }

      .j-meta {
        margin: 0 !important;
        position: relative !important;
        padding: 0.5rem 0 !important;

        a.j-social {
          font-size: 24px;
          &::before {
            margin-right: 0;
          }
        }

        .j-date,
        .j-twitter-date {
          color: $text-color !important;
          font-weight: lighter;
        }
      }

      .j-message {
        position: relative !important;
        transform: none !important;
        top: unset !important;
        max-height: unset !important;
        padding: 0.5rem 0 !important;
        overflow: hidden;
        font-size: 14px !important;
        font-weight: normal !important;
        line-height: initial !important;

        p,
        .j-twitter-quote-text {
          height: unset;
          color: $text-color !important;
        }

        a {
          color: #0a66c2 !important;
        }
      }

      &:not(.image-post) {
        .j-text {
          justify-content: space-between;
        }
      }
    }
  }
}
</style>
